import controller from './buy.controller';

export default {
  bindings: {
    packet: '<'
  },
  controller,
  template: require('./buy.html')
};



// WEBPACK FOOTER //
// src/app/no-auth/buy/buy.component.ts